<template>
  <div class="chooseContactHolder fCol jCenter aCenter">
    <div class="closeArea" @click="closeChooser"></div>
    <div class="contactChoosBox secondary fCol jStart aCenter">
      <!-- نوار بالا -->
      <div class="fRow jStart aCenter topRow fullWidth primary">
        <i class="material-icons-round" v-if="chooseMode">contact_page</i>
        <i class="material-icons-round" v-if="!chooseMode">person_add</i>
        <div class="tt fCol jCenter aStart growFull">
          <div class="t" v-if="chooseMode">انتخاب مخاطب</div>
          <div class="t" v-if="!chooseMode">اضافه کردن</div>
          <span v-if="chooseMode">برای شروع چت یا ارسال پیام یک مخاطب را انتخاب کنید</span>
          <span v-if="!chooseMode">برای اضافه کردن مخاطب اطلاعات را وارد کنید</span>
        </div>
      </div>
      <div v-if="chooseMode" class="contactsList growFull fullWidth">
        <contact-item v-for="(contact, index) in sorted" v-bind:key="index"
          :avatar="contact.avatar"
          :id="contact.id"
          :phone="contact.phone"
          :name="contact.name"/>
      </div>
      <div v-if="!chooseMode" class="addContact growFull fullWidth">
        <div class="iwrapper fRow jStart aCenter wrap">
          <i v-bind:class="{ready: nameIsReady}"
            class="material-icons-round transition-fast">person</i>
          <span>نام مخاطب را وارد کنید</span>
          <span class="growFull fRow jEnd">{{nameLen}}/{{nameToAdd.length}}</span>
          <input class="transition-fast growFull"
            placeholder="نام مخاطب"
            v-bind:class="{ready: nameIsReady}"
            type="text" v-model="nameToAdd">
        </div>
        <div class="iwrapper fRow jStart aCenter wrap">
          <i v-bind:class="{ready: phoneIsReady}"
            class="material-icons-round transition-fast">dialpad</i>
          <span>شماره همراه را وارد کنید</span>
          <span class="growFull fRow jEnd">{{phoneLen}}/{{phone.length}}</span>
          <input class="transition-fast growFull"
            placeholder="شماره همراه را وارد کنید"
            v-bind:class="{ready: phoneIsReady}"
            type="number" v-model="phone">
        </div>
        <div class="iwrapper fRow jStart aCenter wrap">
          <i v-bind:class="{ready: idIsReady}"
            class="material-icons-round transition-fast">alternate_email</i>
          <span>نام کاربری مخاطب را وارد کنید</span>
          <span class="growFull fRow jEnd">{{idLen}}/{{idToAdd.length}}</span>
          <input class="transition-fast growFull"
            placeholder="نام کاربری"
            v-bind:class="{ready: idIsReady}"
            type="text" v-model="idToAdd">
        </div>
        <div class="createContact appBtn fRow jStart aCenter primary"
          v-bind:class="{
            active: readyToCreate
          }"
          @click="createNewContact"
          style="width: 170px; margin: 16px 16px 0 16px; color: white" v-ripple>
          <i class="material-icons-round">add_box</i>
          <label>ایجاد مخاطب جدید</label>
        </div>
      </div>
      <!-- نوار پایین -->
      <div class="fRow jBetween aCenter bottomRow fullWidth">
        <div v-ripple class="btnss primary"
          @click="chooseMode = false"
          v-if="chooseMode">اضافه کردن مخاطب</div>
        <keep-alive>
          <div v-ripple class="btnss"
            @click="chooseMode = true"
            v-if="!chooseMode">بازگشت و انتخاب مخاطب</div>
        </keep-alive>
        <div v-ripple class="btnss" @click="closeChooser">بستن</div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactItem from '@/components/ContactItem.vue';

export default {
  data() {
    return {
      chooseMode: true,
      phone: '',
      phoneLen: 11,
      idToAdd: '',
      idLen: 32,
      nameToAdd: '',
      nameLen: 48,
      contacts: [
        {
          name: 'علی ابراهیم زاده',
          id: 'aliali',
          phone: '09305556322',
          avatar: 'https://api.rimik.ir/photo/4bb8eb17-2413-4497-9093-44f1ca691b79.jpg',
        },
        {
          name: 'مهدی عبدی',
          id: 'mehdi_72',
          phone: '09123654998',
          avatar: 'https://api.rimik.ir/photo/9c4e0e86-8557-43ca-9030-2a63f558befb.jpg',
        },
        {
          name: 'الهام',
          id: 'elhamx',
          phone: '',
          avatar: '',
        },
        {
          name: 'مهرداد سلمانیان',
          id: 'mehrdads',
          phone: '09213354760',
          avatar: 'https://api.rimik.ir/photo/c5246a51-f253-48c4-8084-6de67f4e2d78.jpg',
        },
        {
          name: 'علی بابانژاد',
          id: 'ababanejad',
          phone: '09105956322',
          avatar: 'https://api.rimik.ir/photo/4bb8eb17-2413-4497-9093-44f1ca691b79.jpg',
        },
        {
          name: 'احمدرضا عزیزی',
          id: 'mehdi_72',
          phone: '09133654998',
          avatar: 'https://api.rimik.ir/photo/9c4e0e86-8557-43ca-9030-2a63f558befb.jpg',
        },
        {
          name: 'علیرضا',
          id: 'alireza_alireza',
          phone: '',
          avatar: '',
        },
        {
          name: 'محمد عبداللهی',
          id: 'moabd',
          phone: '09213384760',
          avatar: 'https://api.rimik.ir/photo/c5246a51-f253-48c4-8084-6de67f4e2d78.jpg',
        },
      ],
    };
  },
  computed: {
    phoneIsReady() {
      return this.pir();
    },
    idIsReady() {
      return this.iir();
    },
    nameIsReady() {
      return this.nir();
    },
    readyToCreate() {
      // eslint-disable-next-line
      return (this.phoneIsReady && this.nameIsReady) || (this.idIsReady && this.nameIsReady) || (this.idIsReady && this.nameIsReady && this.phoneIsReady);
    },
    sorted() {
      return this.sortContacts();
    },
  },
  methods: {
    pir() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      // eslint-disable-next-line
      const cond = this.phone.toString().match(phonePattern) && (this.phone.toString().charAt(0) === '0' && this.phone.toString().charAt(1) === '9');
      if (cond) {
        return true;
        // eslint-disable-next-line
      } else if (this.phone.length > 11) {
        this.fitTo('phone');
        return true;
      }
      return false;
    },
    iir() {
      let idready = false;
      for (let i = 0; i <= this.idToAdd.length; i += 1) {
        if (this.idToAdd.charAt(i) !== '@' && this.idToAdd.length > 4) {
          if (this.idToAdd.length > this.idLen) {
            this.fitTo('id');
          }
          idready = true;
        }
      }
      return idready;
    },
    nir() {
      let nameready = false;
      if (this.nameToAdd.length > 3) {
        if (this.nameToAdd.length > this.nameLen) {
          this.fitTo('name');
        }
        nameready = true;
      }
      return nameready;
    },
    fitTo(str) {
      switch (str) {
        case 'id': {
          // id
          this.idToAdd = this.idToAdd.substr(0, this.idLen);
          break;
        }
        case 'name': {
          // name
          this.nameToAdd = this.nameToAdd.substr(0, this.nameLen);
          break;
        }
        case 'phone': {
          // phone
          this.phone = this.phone.substr(0, this.phoneLen);
          break;
        }
        default:
          break;
      }
    },
    compare(a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    },
    sortContacts() {
      return this.contacts.sort(this.compare);
    },
    createNewContact() {
      if (this.readyToCreate) {
        this.contacts.push({
          name: this.nameToAdd,
          id: Math.floor(Math.random() * 20000000),
          avatar: '',
          phone: this.phone,
        });
        this.chooseMode = true;
      }
    },
    closeChooser() {
      this.$emit('close');
    },
  },
  components: {
    ContactItem,
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.chooseContactHolder {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 56px;
  right: 0;
  background-color: #0000008a;
  z-index: 3000000;
  .closeArea {
    position: absolute;
    top: inherit;
    left: inherit;
    bottom: 0;
    right: inherit;
    z-index: 3;
  }
  .contactChoosBox {
    border-radius: 8px;
    width: calc(100% - 32px);
    height: calc(100% - 64px);
    max-width: 360px;
    max-height: 500px;
    overflow: hidden;
    z-index: 5;
    box-shadow: 0 16px 32px 0 rgba($color: #000000, $alpha: 0.4);
    .topRow, .bottomRow {
      height: 56px;
      min-height: 56px;
      padding: 0 8px;
      box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.2);
      i {
        margin-left: 16px;
        color: white;
      }
      i.closeit {
        color: red;
        margin-left: 0;
        margin-right: 8px;
      }
      .tt {
        .t {
          font-size: 16px;
          font-weight: 100;
          color: white;
          line-height: 1;
          margin-bottom: 8px;
          text-align: right;
        }
        span {
          font-size: 10px;
          font-weight: 100;
          color: rgba(255, 255, 255, 0.589);
          line-height: 1;
          text-align: right;
        }
      }
      .btnss {
        border-radius: 48px;
        color: white;
        padding: 8px 16px;
        font-size: 12px;
        font-weight: 200;
        cursor: pointer;
      }
      .btnss::hover {
        box-shadow: 0 8px 8px 0 rgba($color: #000000, $alpha: 0.4);
      }
    }
    .contactsList, .addContact{
      overflow-x: hidden;
      overflow-y: auto;
      $deadText: rgba(255, 255, 255, 0.212);
      $ready: rgb(106, 211, 46);
      .iwrapper {
        padding: 8px 16px 0;
        span {
          font-size: 12px;
          font-weight: 100;
          color: white;
          padding: 8px 0;
          text-align: right;
        }
        i {
          font-size: 16px;
          color: $deadText;
          margin-left: 8px;
        }
        i.ready {
          color: $ready
        }
        input {
          border: none;
          outline: none;
          padding: 8px 16px;
          border-radius: 8px 8px 0 0;
          border-bottom: solid 2px $deadText;
          color: white;
          background-color: rgba(255, 255, 255, 0.055);
        }
        input.ready {
          border-bottom: solid 2px $ready;
        }
      }
    }
    .addContact {
      padding: 8px;
    }
  }
}
</style>
